<template>
  <div class="container">
    <!-- 页面标题和菜单栏 -->
    <div class="container01">
      <h1 class="container01_h1">客户管理</h1>
      <!-- 菜单栏按钮 -->
      <el-row :gutter="20">
        <el-col :span="24" class="button-col">
          <div class="container01_button">
            <el-button @click="$router.back()">返回上一级</el-button>
            <el-button type="primary" @click="handleAddCustomer">新增客户</el-button>
            <el-button type="primary" @click="handleBatchImport">批量导入</el-button>
            <el-button type="danger" @click="handleBatchDelete"
              :disabled="selectedCustomerIds.length === 0">删除选中客户</el-button>
            <el-button type="primary" @click="handleSalesCustomer">销售客户</el-button>
            <el-button type="primary" @click="handleAccountCustomer" style="margin-right: 10px;">走账客户</el-button>
          </div>
        </el-col>
      </el-row>
      <!-- 搜索栏 -->
      <el-row :gutter="20">
        <el-col :span="24" class="search-col">
          <el-input v-model="searchKeyword" placeholder="请输入客户名称或联系方式，支持模糊搜索" clearable class="container01_search"
            @keyup.enter="handleSearch"></el-input>
          <el-button type="primary" @click="handleSearch" style="margin-top: 20px;">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 信息表格 -->
    <div class="container02">
      <div>
        <el-table :data="paginatedData" border style="width: 100%" height="calc(100vh - 200px)" v-loading="loading"
          element-loading-text="加载中" v-model="selectedCustomerIds" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="customer_id" label="ID" width="55" />
          <el-table-column prop="name" label="客户名称" min-width="5%" />
          <el-table-column prop="contact" label="联系方式" min-width="5%" />
          <el-table-column prop="address" label="地址" min-width="10%" />
          <el-table-column label="操作" min-width="3%">
            <template #default="scope">
              <el-button type="text" @click="handleViewDetail(scope.row.customer_id)">详情</el-button>
              <el-button type="text" @click="handleDelete(scope.row.customer_id)"
                style="color: rgb(250,182,182);">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页按钮 -->
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage <= 1" class="page-button">上一页</button>
          <span class="page-info">当前第 {{ currentPage }} 页 / 共 {{ totalPages }} 页 - 共 {{ totalCount }} 条数据</span>
          <button @click="nextPage" :disabled="currentPage >= totalPages" class="page-button">下一页</button>
        </div>
      </div>
    </div>
    <!-- 新增客户 -->
    <el-dialog title="新增客户" v-model="addDialogVisible">
      <el-form :model="newCustomer" ref="form">
        <el-form-item label="客户名称" required>
          <el-input v-model="newCustomer.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="newCustomer.contact" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="newCustomer.address" placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCustomer">保存</el-button>
      </template>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog title="批量导入" v-model="importDialogVisible">
      <div class="import-area">
        <input type="file" ref="fileInput" accept=".xlsx,.json" @change="handleFile">
        <button @click="triggerFile">选择Excel或JSON文件</button>
        <p v-if="fileName">{{ fileName }}</p>
      </div>
      <template #footer>
        <el-button @click="downloadTemplate">下载模板</el-button>
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doImport" :disabled="!fileName">导入</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import request from '@/utils/request';
import customersAPI from '@/api/customers';

export default {
  data() {
    return {
      customers: [],
      searchKeyword: '',
      loading: false,
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      currentDB: 'sales',
      addDialogVisible: false,
      importDialogVisible: false,
      newCustomer: { name: '', contact: '', address: '' },
      fileName: '',
      file: null,
      selectedCustomerIds: []
    }
  },
  created() {
    this.fetchCustomersData();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize) || 1
    },
    paginatedData() {
      return this.customers
    }
  },
  methods: {
    async fetchCustomersData() {
      this.loading = true;
      try {
        const params = {
          keyword: this.searchKeyword,
          page: this.currentPage,
          per_page: this.pageSize
        }
        const originData = await customersAPI.inquireCustomers(params);
        const customerList = Array.isArray(originData.customers) ? originData.customers : [];
        this.customers = customerList;
        this.totalCount = originData.total || 0;
        this.currentPage = originData.page || 1;
      } catch (error) {
        console.log("获取数据有误", error);
      } finally {
        this.loading = false;
      }
    },
    async saveCustomer() {
      if (!this.newCustomer.name.trim()) {
        this.$message.warning('客户名称不能为空');
        return
      }
      try {
        await customersAPI.createCustomer(this.newCustomer);
        this.$message.success('新增成功');
        this.addDialogVisible = false;
        this.newCustomer = { name: '', contact: '', address: '' };
        this.fetchCustomersData();
      } catch (err) {
        console.error('新增失败', err);
        this.$message.error('新增失败');
      }
    },
    triggerFile() {
      this.$refs.fileInput.value = ''
      this.$refs.fileInput.click();
    },
    handleFile(e) {
      const file = e.target.files[0];
      if (file) {
        const allowedTypes = ['application/json', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const allowedExtensions = ['.json', '.xlsx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
          this.$message.error("仅支持JSON和XLSX类型的文件");
          this.file = null;
          this.fileName = '';
          return;
        }
        this.file = file;
        this.fileName = file.name;
      }
    },
    async doImport() {
      if (!this.file) {
        this.$message.error("请选择文件");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.file);

      try {
        await request.post("/api/customers/batch", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        this.$message.success("导入成功");
        this.importDialogVisible = false;
        this.fileName = "";
        this.fetchCustomersData();
        this.$refs.fileInput.value = "";
      } catch (err) {
        console.error("导入失败详情:", err.response?.data || err);
        this.$message.error(err.response?.data?.message || "导入失败");
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchCustomersData();
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchCustomersData();
    },
    handleAddCustomer() {
      this.addDialogVisible = true;
    },
    handleBatchImport() {
      this.importDialogVisible = true;
    },
    handleViewDetail(customerID) {
      this.$router.push(`/customers/detail/${customerID}`);
    },
    handleSalesCustomer() {
      this.$message.info('销售客户功能待实现');
    },
    handleAccountCustomer() {
      this.$message.info('走账客户功能待实现');
    },
    handleSelectionChange(selectedRows) {
      this.selectedCustomerIds = selectedRows.map(row => row.customer_id);
    },
    async handleDelete(customerId) {
      try {
        await this.$confirm('确定要删除该客户吗？删除后数据不可恢复！', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await customersAPI.deleteCustomer(customerId);
        this.$message.success('客户删除成功！');
        this.fetchCustomersData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败：', error);
          this.$message.error('删除失败，请重试！');
        }
      }
    },
    async handleBatchDelete() {
      try {
        if (this.selectedCustomerIds.length === 0) {
          this.$message.warning('请先选中要删除的客户！');
          return;
        }
        await this.$confirm(`确定要删除选中的 ${this.selectedCustomerIds.length} 个客户吗？删除后数据不可恢复！`, '批量删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await customersAPI.batchDeleteCustomers(this.selectedCustomerIds);
        this.$message.success('批量删除成功！');
        this.fetchCustomersData();
        this.selectedCustomerIds = [];
      } catch (error) {
        if (error !== 'cancel') {
          console.error('批量删除失败：', error);
          this.$message.error('批量删除失败，请重试！');
        }
      }
    },
    downloadTemplate() {
      // 定义表头
      const headers = ['name', 'contact', 'address']
      // 示例数据
      const exampleRow = ['张三', '13800138000', '示例地址']
      const csvContent = [
        headers.join(','),
        exampleRow.join(',')
      ].join('\n')

      // 创建 Blob 并下载
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' }) // BOM 使 Excel 正确识别 UTF-8
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', '客户批量导入模板.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.container01_h1 {
  text-align: center;
  margin-bottom: 24px;
  font-size: 28px;
  font-weight: 600;
  background: linear-gradient(135deg, #1e293b, #3b82f6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.container01_button {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
}

.search-col {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 20px;
}

.container01_search {
  flex: 1;
  min-width: 200px;
}

.container02 {
  width: 100%;
  margin-top: 20px;
  overflow-x: auto;
}

.el-table {
  border-radius: 16px;
  overflow: hidden;
}

.el-table__row:hover>td {
  background-color: #fef9e3 !important;
}

.el-button--text {
  margin: 0 4px;
  transition: all 0.2s;
}

.el-button--text:hover {
  transform: translateY(-1px);
  color: var(--primary-color);
}

.el-dialog .el-form-item {
  margin-bottom: 20px;
}

.el-dialog .el-input__inner {
  border-radius: 12px;
}

.import-area {
  padding: 20px;
  text-align: center;
  border: 2px dashed #e2e8f0;
  border-radius: 20px;
  background: #fafcff;
  transition: all 0.2s;
}

.import-area:hover {
  border-color: var(--primary-color);
  background: #f0f9ff;
}

.import-area button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 40px;
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.import-area button:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .container {
    padding: 12px !important;
  }

  .container01_button {
    flex-direction: column;
    gap: 8px;
  }

  .search-col {
    flex-direction: column;
    align-items: stretch;
  }

  .container01_search {
    width: 100%;
    margin-right: 0;
    margin-top: 0;
  }

  .el-button {
    width: 100%;
    margin: 0 !important;
  }

  .container02 {
    width: 100%;
  }

  .el-table {
    font-size: 12px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>